// The composed Label per-artist dashboard read — ONE band-scoped query for the 4-card
// dashboard (Music / Marketing / Content / To-dos). Hand-written over the generated client via the tenant-keyed
// wrapper: keyed ['band', bandId, 'roster', 'dashboard'] so an artist switch SCORCHES it (the
// close, switchRosterArtist). The hook calls the BAND-DIRECT path; under the roster shell the org-lens middleware
// (app/orgLens.ts) splices `/orgs/{orgId}` so it resolves the money-free `/orgs/{orgId}/bands/{bandId}/dashboard`
// mirror — the feature hook never writes the org prefix. MONEY-FREE by construction.
import type { components } from "@cntrl/api-client";
import { useApp } from "../appContext.js";
import { useBandQuery } from "./useBandQuery.js";
import { ApiError } from "./apiError.js";

export type RosterArtistDashboardRead = components["schemas"]["RosterArtistDashboardRead"];

/** GET the composed per-artist Label dashboard (roster:read, org-lens only). `staleTime` ~60s (stats domain). */
export function useRosterArtistDashboard() {
  const { api } = useApp();
  return useBandQuery<RosterArtistDashboardRead>(
    ["roster", "dashboard"],
    async (bandId) => {
      const { data, error, response } = await api.GET("/api/v1/bands/{bandId}/dashboard", {
        params: { path: { bandId } },
      });
      if (!response.ok || !data?.data) throw new ApiError(response.status, error);
      return data.data;
    },
    { staleTime: 60_000 },
  );
}
